class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.setLiveRegionAttributes();

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
  }

  setLiveRegionAttributes() {
    this.statusElement = document.createElement('div');
    this.statusElement.setAttribute('aria-live', 'polite');
    this.statusElement.setAttribute('role', 'status');
    this.statusElement.classList.add('visually-hidden');
    this.appendChild(this.statusElement);
  }

  onChange(event) {
  const form = this.closest('form') || this.querySelector('form');

  if (!form) {
    console.error('SearchForm: No form found.');
    return;
  }

  const formData = new FormData(form);
  const params = new URLSearchParams(formData).toString();

  fetch(`${form.action}?${params}&section_id=predictive-search`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const newResults = html.querySelector('#predictive-search-results');

      document
        .querySelector('#predictive-search-results')
        ?.replaceWith(newResults);

      const resultCount = newResults?.querySelectorAll('.predictive-search__list-item').length || 0;
      const searchTerm = this.input.value;

      this.statusElement.textContent = `${resultCount} results for “${searchTerm}”`;
    });
}


  debounce(fn, delay) {
    let timer = null;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(context, args);
      }, delay);
    };
  }
}

customElements.define('search-form', SearchForm);
window.SearchForm = SearchForm;
